import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {VitalSignType} from '@shared/models/vital-sign.model';
import {ResponsiveService, responsiveBreakpoints} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {Subscription} from 'rxjs';
import {configVariableValues} from '@constants/config-variable-values.constants';

@Component({
  selector: 'si-vit-vital-sign-chart-parent',
  templateUrl: './vit-vital-sign-chart-parent.component.html',
  styleUrls: ['./vit-vital-sign-chart-parent.component.scss']
})
export class VitVitalSignChartParentComponent {
  @Input() sizePage = 9;
  @Input() showTitle = true;
  @Input() showRecordButton = true;
  @Input() useLoader = true;
  @Input() hideChart: boolean;
  @Input() chartHeight: string;
  @Output() onAverageChange = new EventEmitter<number>();
  subscriptions: Subscription[] = [];
  isMobileWidth: boolean;
  responsiveBreakPoints = responsiveBreakpoints;
  model: VitalSignType;
  average: string;
  configVariableValues = configVariableValues;

  constructor(
    private responsiveService: ResponsiveService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.setResponsiveLogic();
  }

  setResponsiveLogic(): void {
    this.subscriptions.push(
      this.responsiveService.getResponsiveStoreObservable().subscribe(responsiveStore => {
        this.isMobileWidth = responsiveStore.currentWindowWidth < this.responsiveBreakPoints.XS;
      })
    );
  }

  onChangeVitalSign(model: VitalSignType): void {
    this.model = model;
    this.changeDetectorRef.detectChanges();
  }

  onChangeAverage(average: number) {
    this.average = average?.toFixed(2);
    this.onAverageChange.emit(average);
  }
}
